import React, { useState } from 'react';
import DashboardLayout from '../../../layout/dashboard';
import { Button } from 'primereact/button';
// import Terms from './Terms';
import Document from '../commonComponents/Document/producer';
import CustomButton from "shared/components/inputButton";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Avatar } from 'primereact/avatar';
import { Divider } from 'primereact/divider';

export default function ContactReview() {
    const [activeIndex, setActiveIndex] = useState(0);
    return (
        <div className="contract-review">
            <h1>Contract Review</h1>
            <p className='color-grey mb-2'>Please sign up for an athena-io account and create a contract with us to enable reviewing.</p>
            <p className='color-grey mb-2'>Not an athena-io contract? Refer your collaborator to sign up now.</p>
            <Accordion activeIndex={0} className='contract-review-accordion mb-2'>
                <AccordionTab header="Track Contracts">
                    <p className="m-0">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                        Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
                        commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                        Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                    </p>
                </AccordionTab>
                <AccordionTab header="Contract Available for Review">
                    <div className="grid w-full">
                        <div className="md:col-4">
                            <p className='color-grey border-bottom-1 border-400 py-2 m-0'>Name</p>
                            <p className='font-bold py-2 m-0'>Music Video Agreement 124.pdf</p>
                        </div>
                        <div className="md:col-4">
                            <p className='color-grey border-bottom-1 border-400 py-2 m-0'>Date</p>
                            <p className='font-bold py-2 m-0'>3 November 2024</p>
                        </div>
                        <div className="md:col-4">
                            <p className='color-grey border-bottom-1 border-400 py-2 m-0'>Owner </p>
                            <p className='font-bold py-2 m-0 flex gap-3 align-items-center'><Avatar image="/images/avatar/onyamalimba.png" shape="circle" />Chris Jenkins</p>
                        </div>
                    </div>
                </AccordionTab>
            </Accordion>
            <div className="bg-main my-4 p-4">
                <h2 className="text-lg text-white">Music Video Agreement 124</h2>
                <div className="grid mt-4">
                    <div className="md:col-3">
                        <p className="text-white">Date</p>
                        <Divider />
                        <p className="font-bold text-white">3 November 2024</p>
                    </div>
                    <div className="md:col-3">
                        <p className="text-white">Owner</p>
                        <Divider />
                        <div className="flex align-items-center gap-3">
                            <Avatar
                                image="/images/avatar/onyamalimba.png"
                                shape="circle"
                            />
                            <p className="font-bold text-white m-0">Chris Jenkins</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex justify-content-between align-items-center">
                <div className="flex tab-buttons mb-2 gap-7 justify-content-end">
                    <Button onClick={() => setActiveIndex(0)} className={`bg-transparent border-none ${activeIndex === 0 ? 'active' : ''}`} rounded outlined={activeIndex !== 0} label="Terms" />
                    <Button onClick={() => setActiveIndex(1)} className={`bg-transparent border-none ${activeIndex === 1 ? 'active' : ''}`} rounded outlined={activeIndex !== 1} label="Document" />
                    
                </div>
                <CustomButton label="Sign" extraClass="w-auto border-round-3xl" />
            </div>
            <div className="mt-4">
                {/* {activeIndex === 0 && <Terms />} */}
                {activeIndex === 1 && <Document />}
            </div>
        </div>
    )
}
